import aikoutuIcon from '@/assets/img/icons/aikoutu.png'
import { iconStyle } from './AiKoutuIcon'

export function PsIcon() {
  return (
    <div style={iconStyle}>
      <img src={aikoutuIcon} alt="ai抠图" />
    </div>
  )
}
import aikoutuIcon from '@/assets/img/icons/aikoutu.png'
import { iconStyle } from './AiKoutuIcon'

export function PsIcon() {
  return (
    <div style={iconStyle}>
      <img src={aikoutuIcon} alt="ai抠图" />
    </div>
  )
}
